import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "./FolderLogin.css";

const API_ADMIN_LOGIN_URL = `${process.env.REACT_APP_ADMIN_API_URL}/admin-login`;

export const FolderLogin = () => {
  const navigate = useNavigate();

  const [passkey, setPasskey] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleChange = (e) => {
    setPasskey(e.target.value);
    setError("");
  };

  const handleLogin = async (e) => {
    e.preventDefault();

    if (!passkey.trim()) {
      setError("Please enter admin passkey");
      return;
    }

    try {
      setLoading(true);
      setError("");

      const res = await axios.post(API_ADMIN_LOGIN_URL, { passkey });

      if (!res.data.success) {
        throw new Error(res.data.message || "Login failed");
      }
      if(res.data.role === "fadmin"){
        sessionStorage.setItem("fadmin", "true");
        sessionStorage.setItem("ftoken", res.data.token);
      }
      
      alert("Admin Login Successful");
      sessionStorage.setItem("FAdminLogin", true);
      navigate("/FinalComponent");
    } catch (err) {
      console.error(err);
      setError(
        err?.response?.data?.message || err.message || "Login failed"
      );
    } finally {
      setLoading(false);
    }
  };
  return (
    <div className="folder-login-page">
      <div className="folder-login-card">
        <div className="folder-login-top">
          <h1>Admin Login</h1>
          <p>Enter secure passkey to access admin panel</p>
        </div>

        <form className="folder-login-form" onSubmit={handleLogin}>
          <div className="form-group">
            <label>Passkey</label>
            <input
              type="password"
              value={passkey}
              onChange={handleChange}
              placeholder="Enter fadmin passkey"
              autoFocus
            />
          </div>

          {error && <p className="error-message">{error}</p>}

          <button
            type="submit"
            className="folder-login-btn"
            disabled={loading}
          >
            {loading ? "Logging in..." : "Login"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default FolderLogin;